import secondaryComponents from "../..";
import { useActivityLogsTable } from "./useActivityLogsTable";

export const ActivityLogsTable = ({
  activityLogs,
  metaDetails = {},
  gotoPage = () => {},
}) => {
  const { instance } = useActivityLogsTable({
    activityLogs,
  });
  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
    instance;

  return (
    <>
      <secondaryComponents.TableHelper
        getTableProps={getTableProps}
        getTableBodyProps={getTableBodyProps}
        headerGroups={headerGroups}
        rows={rows}
        prepareRow={prepareRow}
        hasAction={true}
      >
        <div className="text-center my-5">
          <h4 className="">No Data Available</h4>
        </div>
      </secondaryComponents.TableHelper>

      {activityLogs?.length > 0 && (
        <div className="mt-auto">
          <secondaryComponents.Pagination
            totalPageNumber={metaDetails?.last_page}
            handlePageClick={(value) => gotoPage(value?.selected + 1)}
            currentPage={metaDetails?.current_page}
          />
        </div>
      )}
    </>
  );
};
